import { GlobalContext } from "@/contexts";
import { SearchParamType } from "@/types/SearchParamType";
import { useContext } from "react";
import { useSearchParams } from "react-router-dom";
/**
 * Hook that safely gets the country parameter from URL, with fallback to default country
 * This ensures all components get a consistent country value even during initialization
 */
export var useCountryParam = function () {
    var countryConfig = useContext(GlobalContext).countryConfig;
    var searchParams = useSearchParams()[0];
    var countryFromUrl = searchParams.get(SearchParamType.COUNTRY);
    // Return country from URL if available, otherwise fallback to default
    return countryFromUrl || countryConfig.selectedCountry || "";
};
